// Google翻訳のプラグイン
export default function GOOG_TRANSLATE(gaId){
  const [w,d] = [window,document]
  const trig_query = '[data-plugin="switch_language"]'
  const close = () => {
    $('.goog-te-menu-frame:eq(0)').removeClass('visible');
  }
  w.googleTranslateElementInit = () => {
    w.load.header.then(()=>{
      if( d.querySelectorAll(trig_query).length == 0 ) return
      const toggl = d.querySelector(trig_query)
      const includedLanguages = toggl.dataset.lang
      new google.translate.TranslateElement({
            pageLanguage: 'ja',
            includedLanguages,
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
            gaTrack: true,
            gaId
          },'google_translate_element');
      $(toggl).on('click',e => {
        const coord = e.currentTarget.getBoundingClientRect()
        const pos = {
          top: coord.top + coord.height,
          right: window.innerWidth - coord.left - coord.width
        }
        $('.goog-te-menu-frame:eq(0)').css(pos).toggleClass('visible');
      });
    })
  }
  $(d).on('click touchend',e => {
    if ( !$(e.target).closest(trig_query).length && !$(e.target).closest('.goog-te-menu-frame:eq(0)').length)
      close()
  })
}